import { useTranslation } from "react-i18next";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { calendarHolidaysManagement } from "../../../../../../hooks/api/CalendarHolidaysManagement";
import { Slide, toast, ToastContainer } from "react-toastify";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { Formik } from "formik";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";
import { Textarea } from "../../../../../../themes/Default/components/Form/components/Textarea";
import { Select } from "../../../../../../themes/Default/components/Form/components/Select";
import { prepareSelect } from "../../../../../../services/core/Select";
import ColorPicker from "../../../../../../themes/Default/components/Form/components/ColorPicker/ColorPicker";
import DatePicker from "../../../../../../themes/Default/components/Form/components/DatePicker/DatePicker";

const EditHoliday = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const { holidayId } = useParams();
    const [formErrors, setFormErrors] = useState([]);
    const { useUpdateCalendarHolidaysMutation, useViewCalendarHolidaysMutation} = calendarHolidaysManagement;
    const [updateHoliday, {isLoading: isUpdateingHoliday}] = useUpdateCalendarHolidaysMutation();
    const [viewHoliday] = useViewCalendarHolidaysMutation();

    const tabs = [
        { title: t('calendarHolidays.title'), isActive: true},
    ];

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        const body = {...values};
        updateHoliday({body, holidayId}).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/settings/calendar/holidays");
                toast.info(result?.data?.info?.responseMessage);
            }
        });
    };

    useEffect(() => {
        viewHoliday(holidayId).then((result) => {
            formRef.current.setValues(result?.data);
            console.log(result?.data);
        });

    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings/calendar/holidays" />
                <Button title={t('save')} isDisabled={isUpdateingHoliday} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("calendar.title")} />
                    <Link title={t("calendarHolidays.title")} />
                    <Link title={t("calendarHolidays.editOne")} isActive={true} />
                </Breadcrumps>
                <Formik
                        innerRef={formRef}
                        initialValues={{
                            title: "",
                            date: "",
                            description: "",
                            isRecurring: "",
                            color: "",
                        }}
                        onSubmit={onSaved}
                    >
                    {({ values, handleChange, setFieldValue }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Input
                                        name="title"
                                        label={t("calendarHolidays.titleCalendarHolidays")}
                                        required={true}
                                        value={values.title}
                                        onChange={handleChange}
                                        error={formErrors?.title}
                                    />
                                </Field>   
                                <Field>
                                    <DatePicker
                                        name="date"
                                        label={t("calendar.date")}
                                        value={values.date}
                                        onChange={handleChange}
                                        error={formErrors?.date}
                                    />
                                </Field>  
                            </Row>
                            <Row>
                                <Field isFullWidth={true}>
                                    <Textarea
                                        rows={5}
                                        name="description"
                                        label={t("calendarHolidays.description")}
                                        value={values.description}
                                        onChange={handleChange}
                                        error={formErrors?.description}
                                    />
                                </Field> 
                            </Row>
                            <Row>
                                <Field>
                                    <Select
                                        name="isRecurring"
                                        label={t("calendarHolidays.isRecurring")}
                                        options={prepareSelect([
                                            { id: true, name: t("calendarHolidays.isRecurringYes") },
                                            { id: false, name: t("calendarHolidays.isRecurringNo") },
                                        ])}
                                        onChange={(e) => {
                                            handleChange(e);
                                        }}
                                        selectedValue={values.isRecurring}
                                        error={formErrors?.isRecurring}
                                        searchVisible={false} 
                                    />
                                </Field> 
                                <Field>
                                    <ColorPicker
                                        name="color"
                                        label={t("calendarHolidays.color")}
                                        value={values.color}
                                        onChange={handleChange}
                                        error={formErrors?.color}
                                    />
                                </Field> 
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};


export default EditHoliday;
